import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { DataTable, DataTableProps } from '@warrenbrasil/nebraska-web';
import { columns } from './columns';
import {
  getPlannedAllocation,
  IPlannedItems
} from '@/modules/wealth/services/portfolio-allocation';

interface Props {
  plannedTable: IPlannedItems[];
  portfolioId: string;
  hasApplied: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PlannedTable',
  props: {
    plannedTable: null,
    portfolioId: null,
    hasApplied: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  plannedTable: IPlannedItems[];
  portfolioId: string;
  hasApplied: boolean;
};



const tableData = ref(props.plannedTable);
const isLoading = ref(false);

const productsLength = computed(() => {
  return props.plannedTable.length;
});

const columnsTable = computed(() => {
  return columns(productsLength.value);
});

const dataTableStatus = computed(() => {
  return isLoading.value
    ? DataTableProps.DataTableStatus.Loading
    : DataTableProps.DataTableStatus.Default;
});

async function sortTable(index: number, isSort: boolean, value: string) {
  isLoading.value = true;

  try {
    const direction = isSort ? 'Ascending' : 'Descending';
    const orderBy = index === -1 ? undefined : value;
    const orderType = index === -1 ? undefined : direction;

    const params = { hasApplied: props.hasApplied, orderBy, orderType };

    const data = await getPlannedAllocation(props.portfolioId, params);

    tableData.value = data.items;
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,props, tableData, isLoading, productsLength, columnsTable, dataTableStatus, sortTable, DataTable }
}

})